import { render, staticRenderFns } from "./SameDayRecReport.vue?vue&type=template&id=d210aa52&scoped=true"
import script from "./SameDayRecReport.vue?vue&type=script&lang=ts"
export * from "./SameDayRecReport.vue?vue&type=script&lang=ts"
import style0 from "./SameDayRecReport.vue?vue&type=style&index=0&id=d210aa52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d210aa52",
  null
  
)

export default component.exports